import { render, staticRenderFns } from "./SaleReturnForm.vue?vue&type=template&id=f24ea8d6&"
import script from "./SaleReturnForm.vue?vue&type=script&lang=js&"
export * from "./SaleReturnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports